import { Controller } from "@hotwired/stimulus"

// Submits the form it is attached to as soon as it renders, exactly once.
export default class extends Controller {
  connect() {
    if (this.element.dataset.autosubmitted) return
    this.element.dataset.autosubmitted = "true"
    this.element.requestSubmit()
  }
}
